import * as yup from 'yup';

export const TIME_OPTIONS = [
  {
    label: '10 minutes',
    value: '10',
  },
  {
    label: '20 minutes',
    value: '20',
  },
  {
    label: '30 minutes',
    value: '30',
  },
  {
    label: '40 minutes',
    value: '40',
  },
  {
    label: '50 minutes',
    value: '50',
  },
  {
    label: '1 hour',
    value: '60',
  },
  {
    label: '1 hour, 10 minutes',
    value: '70',
  },
  {
    label: '1 hour, 20 minutes',
    value: '80',
  },
  {
    label: '1 hour, 30 minutes',
    value: '90',
  },
  {
    label: '1 hour, 40 minutes',
    value: '100',
  },
  {
    label: '1 hour, 50 minutes',
    value: '110',
  },
  {
    label: '2 hours',
    value: '120',
  },
];

export const validationSchema = yup.object().shape({
  location: yup.string().required('Please enter a location'),
});
